import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailPanel,
    DetailKvTable,
    DetailSummaryButton,
} from '../../../../components/detailLayout';
import React from "react";
import Th_title from "../../../../components/Th_title";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import {removeInspections} from "../../../../api/maintenance/InspectionService";
import {inspectionRequestCode, useSla} from "../InspectionCreate";
import {useNavigate} from "react-router-dom";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";
import {TaskManager} from "../../shared/TaskManager";
import {MemoList} from "../../../../components/memo/MemoList";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {isMobile} from "../../../../components/commonmethod/CommonMethod";

import {getMaintenanceAssetsFromDetail, getMaintenanceHandlersFromDetail} from "../../shared/maintenanceHandlerUtils";

function InspectionInfo({inspection, statusNumericValue}){
    const navigate = useNavigate();
    const assets = getMaintenanceAssetsFromDetail(inspection);
    const handlers = getMaintenanceHandlersFromDetail(inspection);

    const remove = async () =>{
        const response = await removeInspections({ids: [inspection.id]});
        if (response.status === 200) {
            alert("점검이 정상적으로 삭제되었습니다.");
            navigate("/maintenance/inspection");
        }
    }

    const canAccept = inspection.auth.update && statusNumericValue === ContentStatus.PRE_INSERT.statusNumericValue;

    const summaryMeta = [
        inspection.inspectCode?.name && `코드 ${inspection.inspectCode.name}`,
        inspection.requester?.name && `요청 ${inspection.requester.name}`,
    ].filter(Boolean).join(" · ");

    const requestInfoPanel = (
        <DetailPanel title={"점검요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr>
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top">
                            <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdAt"} value={inspection.createdAt} />
                        </Th_title>
                        <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdBy"} value={inspection.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedAt"} value={inspection.updatedAt} />
                        </Th_title>
                        <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedBy"} value={inspection.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검 제목"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"title"} value={inspection.title} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"requester"} value={inspection.requester} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검코드"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"inspectCode"} value={inspection.inspectCode?.name} />
                        </Th_title>
                        <Th_title title={"요청방식"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"requestCode"} value={ inspectionRequestCode.find(data => data.id === inspection.requestCode) } />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검기간"} colspan={3} className="fieldset-td fieldset-td-input">
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker data={inspection.inspectStartDate} readonly />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker data={inspection.inspectEndDate} readonly />
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"SLA 사용여부"} colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target={"useSla"} value={inspection.useSla ? "사용함" : "사용 안함"} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"비고"} colspan={3} className="fieldset-td">
                            <div className={`align-text-div`}>{inspection.etc}</div>
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const workflowPanels = (
        <>
            <TaskManager
                data={inspection}
                contentCategory={ContentCategory.INSPECTION}
                statusRows={(
                    <>
                        <tr>
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top">
                                <DetailKvListValue items={handlers} listType={KV_LIST_TYPES.user} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"검수자"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"inspector"} value={inspection.inspector} />
                            </Th_title>
                        </tr>
                    </>
                )}
            />

        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent contentId={inspection.id} contentCategory={ContentCategory.INSPECTION_PRE_APPROVE} />
            <ApprovalComponent
                contentId={inspection.id}
                contentCategory={ContentCategory.INSPECTION_POST_APPROVE}
                title={"사후결재"}
                approvalSeparator={true}
            />
            <MemoList entityId={inspection.id} entityName={"Inspection"} />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={inspection.title || "점검 상세"}
            meta={summaryMeta || undefined}
            contentId={inspection.id}
            contentCategory={ContentCategory.INSPECTION}
            scrollMode="columns"
            listUrl="/maintenance/inspection"
            actions={
                canAccept ? (
                    <DetailSummaryButton onClick={() => navigate(`/maintenance/inspection/update/${inspection.id}`)}>
                        접수하기
                    </DetailSummaryButton>
                ) : null
            }
            rollup={{
                remove: !isMobile && inspection.auth.delete && statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue ? remove : "",
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={workflowPanels}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    )
}

export {InspectionInfo}
